// src/util/createInitialLocationFromAddress.js
import { createLocationGroup } from "./db";
import { createLocation } from "./db"; // adjust import paths if needed
import { serverTimestamp } from "firebase/firestore";

export async function createInitialLocationFromSignUpAddress(productionRef,productionData,dayStamp) {
  if (!productionRef?.productionId || !productionData?.productionName) {
    throw new Error("Missing production reference or data");
  }

  const addy = productionData.businessAddress;
  const stringAddress = `${addy.addressLine1}, ${addy.city}, ${addy.state}, ${addy.country}, ${addy.postal_code}`;

  try {
    // Step 1: Get coordinates from address
    const coords = await getCoordsFromAddress(stringAddress);
    console.log("Geocoded address:", coords);

    // Step 2: Create location group
    const colors = [
      "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5",
      "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50",
      "#8bc34a", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"
    ];
    const randomHex = Math.floor(Math.random() * colors.length);

    const locGroupData = {
      productionId: productionRef?.productionId,
      productionName: productionData.productionName,
      name: "PRODUCTION LOCATIONS",
      groupColor: colors[randomHex],
      startDate: dayStamp,
      endDate: dayStamp,
      category: "production",
      customTypes: [],
      sortOrder: 0,
      createdAt: serverTimestamp(),
    };

    const locGroupResponse = await createLocationGroup(locGroupData);

    if (!locGroupResponse.success || !locGroupResponse.id) {
      throw new Error("Failed to create location group");
    }

    console.log("Initial location group created:", locGroupResponse.id);

    // Step 3: Create initial location
    const locationData = {
      groupId: locGroupResponse.id,
      productionId: productionRef?.productionId,
      productionName: productionData.productionName,
      name: `${productionData.businessName}`,
      type: "PRODUCTION OFFICE",
      typeOrder: 2,
      mapData: {
        address: coords.formattedAddress,
        coords: { lat: coords.lat, lng: coords.lng },
      },
      category: "production",
      createdAt: serverTimestamp(),
    };

    const locResponse = await createLocation(locationData);

    if (!locResponse.success) {
      throw new Error("Failed to create initial location");
    }

    console.log("Successfully created initial location for production.");

    // Step 4: Return combined result
    return {
      success: true,
      groupId: locGroupResponse.id,
      locationCreated: true,
      coords,
    };

  } catch (err) {
    console.error("Error creating initial location:", err);
    return { success: false, error: err.message || err };
  }
}

// 📍 Helper function for geocoding address using Google Maps API
async function getCoordsFromAddress(address) {
    if (!window.google || !window.google.maps) {
      throw new Error("Google Maps API not loaded yet");
    }
  
    const geocoder = new window.google.maps.Geocoder();
  
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          resolve({
            lat: location.lat(),
            lng: location.lng(),
            formattedAddress: results[0].formatted_address,
          });
        } else {
          reject(`Geocoding failed: ${status}`);
        }
      });
    });
  }
  